import { useEffect } from 'react';
import styled from '@emotion/styled';
import * as analysisState from '@/components/Analysis/state';
import { useSetAtom } from 'jotai';
import { urlToSVG } from '@/utils';
import { getCloudfrontUrl } from '@/utils/cloudfront';
import useFetchTemplatesByType from '@/hooks/useFetchTemplatesByType';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const DeckPlanDataLoader = ({ ...props }) => {
  const setPoiTemplateIcons = useSetAtom(analysisState.poiTemplateIcons);
  const setAllPointOfInterestTemplates = useSetAtom(analysisState.allPointOfInterestTemplates);
  const { data } = useFetchTemplatesByType();

  useEffect(() => {
    const allTemplates = data?.allPointOfInterestTemplate;
    if (allTemplates) {
      const fetchData = async () => {
        const unresolvedSvgs = allTemplates?.map((template) => {
          return urlToSVG(getCloudfrontUrl(template?.icon?.name ?? ''));
        });

        try {
          const downloadedSvgs = await Promise.all(unresolvedSvgs);
          const svgData = allTemplates.map((template, index) => ({
            name: template.name,
            icon: downloadedSvgs[index],
            color: template.icon?.color ?? '',
            key: template.key ?? '',
          }));
          setPoiTemplateIcons(svgData);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error);
        }
      };
      setAllPointOfInterestTemplates(allTemplates);

      fetchData();
    }
  }, [setAllPointOfInterestTemplates, setPoiTemplateIcons, data?.allPointOfInterestTemplate]);

  return <Wrapper {...props} />;
};
